<template>
	<div>
		<v-container>
			<h1>{{ $t('cv.contact.title') }}</h1>
			<div class="py-2">
				<v-btn
					large
					text
					icon
					color="#4285F4"
					href="mailto:benedek@petrovicz.com"
					rel="noreferrer"
				>
					<v-icon large>fas fa-at</v-icon>
				</v-btn>
				<v-btn
					large
					text
					icon
					color="#0077B5"
					target="_blank"
					href="https://www.linkedin.com/in/bpetrovicz/"
					rel="noreferrer"
				>
					<v-icon large>fab fa-linkedin</v-icon>
				</v-btn>
				<!-- <v-btn large text icon color="#3C5A99" target="_blank" href="https://www.facebook.com/bpetrovicz">
					<v-icon large>fab fa-facebook</v-icon>
				</v-btn> -->
				<v-btn
					large
					text
					icon
					color="#0078FF"
					target="_blank"
					href="https://www.messenger.com/t/bpetrovicz"
					rel="noreferrer"
				>
					<v-icon large>fab fa-facebook-messenger</v-icon>
				</v-btn>
				<!-- <v-btn large text icon color="#1DA1F2" target="_blank" href="https://twitter.com/bpetrovicz">
					<v-icon large>fab fa-twitter</v-icon>
				</v-btn> -->

				<Discord />

				<!-- <v-btn large text icon color="#00AFF0" target="_blank" href="https://join.skype.com/invite/idjPHQ54imtF">
					<v-icon large>fab fa-skype</v-icon>
				</v-btn>
				<v-btn large text icon color="#FF4500" target="_blank" href="https://www.reddit.com/user/bpetrovicz">
					<v-icon large>fab fa-reddit</v-icon>
				</v-btn>
				<v-btn large text icon color="#C13584" target="_blank" href="https://www.instagram.com/bpetrovicz/">
					<v-icon large>fab fa-instagram</v-icon>
				</v-btn>
				<v-btn large text icon color="#FE5000" target="_blank" href="https://soundcloud.com/petrovicz">
					<v-icon large>fab fa-soundcloud</v-icon>
				</v-btn>
				<v-btn large text icon color="#000000" target="_blank" href="https://steamcommunity.com/id/bpetrovicz/">
					<v-icon large>fab fa-steam</v-icon>
				</v-btn> -->
			</div>
		</v-container>

		<v-container>
			<h1>{{ $t('cv.experience.title') }}</h1>

			<v-list
				three-line
				class="transparent"
				v-for="(experience, index) in experiences"
				:key="experience.name"
			>
				<v-list-item>
					<v-list-item-avatar tile size="60">
						<img :src="experience.avatar" />
					</v-list-item-avatar>

					<v-list-item-content>
						<v-list-item-title class="font-weight-bold">{{
							$t('cv.experience.' + experience.name + '.title')
						}}</v-list-item-title>
						<v-list-item-subtitle class="text--primary">{{
							$t('cv.experience.' + experience.name + '.position')
						}}</v-list-item-subtitle>
						<v-list-item-subtitle>{{
							$t('cv.experience.' + experience.name + '.interval')
						}}</v-list-item-subtitle>
					</v-list-item-content>
				</v-list-item>

				<v-divider v-if="index != experiences.length - 1"></v-divider>
			</v-list>
		</v-container>

		<v-container>
			<h1>{{ $t('cv.education.title') }}</h1>

			<v-list
				three-line
				class="transparent"
				v-for="(education, index) in educations"
				:key="education.name"
			>
				<v-list-item>
					<v-list-item-avatar tile size="60">
						<img :src="education.avatar" />
					</v-list-item-avatar>

					<v-list-item-content>
						<v-list-item-title class="font-weight-bold">{{
							$t('cv.education.' + education.name + '.title')
						}}</v-list-item-title>
						<v-list-item-subtitle class="text--primary">{{
							$t('cv.education.' + education.name + '.type')
						}}</v-list-item-subtitle>
						<v-list-item-subtitle>{{
							$t('cv.education.' + education.name + '.interval')
						}}</v-list-item-subtitle>
					</v-list-item-content>
				</v-list-item>

				<v-divider v-if="index != educations.length - 1"></v-divider>
			</v-list>
		</v-container>

		<v-container>
			<h1>{{ $t('cv.volunteer.title') }}</h1>

			<v-list
				three-line
				class="transparent"
				v-for="(volunteer, index) in volunteers"
				:key="volunteer.name"
			>
				<v-list-item>
					<v-list-item-avatar tile size="60">
						<img :src="volunteer.avatar" />
					</v-list-item-avatar>

					<v-list-item-content>
						<v-list-item-title class="font-weight-bold">{{
							$t('cv.volunteer.' + volunteer.name + '.title')
						}}</v-list-item-title>
						<v-list-item-subtitle class="text--primary">{{
							$t('cv.volunteer.' + volunteer.name + '.position')
						}}</v-list-item-subtitle>
						<v-list-item-subtitle>{{
							$t('cv.volunteer.' + volunteer.name + '.interval')
						}}</v-list-item-subtitle>
					</v-list-item-content>
				</v-list-item>

				<v-divider v-if="index != volunteers.length - 1"></v-divider>
			</v-list>
		</v-container>

		<v-container>
			<h1>{{ $t('cv.tools.title') }}</h1>

			<h2>{{ $t('cv.tools.programming') }}</h2>

			<v-chip
				v-for="language in languages"
				:key="language.name"
				color="indigo"
				text-color="white"
				class="ma-1"
			>
				{{ language.name }}
			</v-chip>

			<h2>{{ $t('cv.tools.databases') }}</h2>

			<v-chip
				v-for="database in databases"
				:key="database.name"
				color="teal"
				text-color="white"
				class="ma-1"
			>
				{{ database.name }}
			</v-chip>

			<h2>{{ $t('cv.tools.ides') }}</h2>

			<v-chip
				v-for="ide in ides"
				:key="ide.name"
				:color="ide.color"
				text-color="white"
				class="ma-1"
			>
				{{ ide.name }}
			</v-chip>

			<h2>{{ $t('cv.tools.others') }}</h2>

			<v-chip
				v-for="tool in tools"
				:key="tool.id"
				color="primary"
				text-color="white"
				class="ma-1"
			>
				{{ tool.name }}
			</v-chip>

			<h2>{{ $t('cv.tools.technologies') }}</h2>

			<v-chip
				v-for="technology in technologies"
				:key="technology.name"
				color="brown"
				text-color="white"
				class="ma-1"
			>
				{{ technology.name }}
			</v-chip>
		</v-container>
	</div>
</template>

<script>
import Discord from '@/components/Discord.vue';
import db from '@/plugins/firebase';

import nokia from '@/assets/img/nokia-60x60.png';
import mct from '@/assets/img/mycroptech-60x60.png';
import apor from '@/assets/img/apor-60x60.jpg';
import itk from '@/assets/img/itk-60x60.png';
import hok from '@/assets/img/hok-60x60.png';
import animator from '@/assets/img/animator-60x60.png';
import steam from '@/assets/img/sts-60x60.png';
import dok from '@/assets/img/dok-60x60.png';
import transifex from '@/assets/img/transifex-60x60.png';

export default {
	components: {
		Discord
	},
	data() {
		return {
			languages: [],
			databases: [],
			ides: [],
			tools: [],
			technologies: [],
			experiences: [
				{ avatar: nokia, name: 'nokia-student' },
				{ avatar: nokia, name: 'nokia-specialist' },
				{ avatar: mct, name: 'mct' }
			],
			educations: [
				{ avatar: apor, name: 'apor' },
				{ avatar: itk, name: 'ppke' }
			],
			volunteers: [
				{ avatar: hok, name: 'media-member' },
				{ avatar: hok, name: 'media-head' },
				{ avatar: animator, name: 'animator-active' },
				{ avatar: animator, name: 'animator-veteran' },
				{ avatar: transifex, name: 'transifex' },
				{ avatar: steam, name: 'steam' },
				{ avatar: dok, name: 'apor' }
			]
		};
	},
	firestore() {
		return {
			tools: db.collection('tools').orderBy('id'),
			technologies: db.collection('technologies').orderBy('id'),
			databases: db.collection('databases').orderBy('id'),
			ides: db.collection('ides').orderBy('id'),
			languages: db.collection('languages').orderBy('id')
		};
	}
};
</script>

<style scoped>
h2 {
	margin: 15px 0 5px 0;
}
</style>
